import script from "./method.vue?vue&type=script&setup=true&lang=ts"
export * from "./method.vue?vue&type=script&setup=true&lang=ts"

import "./method.vue?vue&type=style&index=0&id=24f88328&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24f88328"]])

export default __exports__